import { gql } from '@apollo/client';

export const GET_CLIENT_LOGO_QUERY = gql`
  query GetClientLogo($clientId: String!) {
    getBackendServerClientByClientId(clientId: $clientId) {
      logo_url
    }
  }
`;

export const GET_CLIENT_LOGOS_QUERY = gql`
  query GetClientLogos($clientIds: [String!]!) {
    getBackendServerClientsByClientIds(clientIds: $clientIds) {
      id
      logo_url
    }
  }
`;
